export const FJD_OZG_CONTACT_MAIL = "ozg@fjd.de";
export const FJD_OZG_CONTACT_MAILTO = "mailto:ozg@fjd.de";
export const FJD_OZG_CONTACT_PHONE_NUMBER = "089 9902360";
